import { Lock, ArrowLeft } from 'lucide-react';
import { useCompany } from '@/contexts/CompanyContext';

/**
 * The API refused a supplier session ("organization not available"): the customer
 * removed the access. Replaces the page content; the way back leaves the dead row.
 */
export function SupplierAccessRemoved() {
  const { supplierOrg, leaveSupplierSession } = useCompany();
  const supplierName = supplierOrg?.name ?? 'leverandøren';
  return (
    <div className="mx-auto mt-10 max-w-[560px] rounded-2xl border border-bordergray bg-white p-8 text-center dark:border-dark-border dark:bg-dark-card">
      <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-error-light text-error dark:bg-error/20">
        <Lock className="h-6 w-6" />
      </div>
      <h2 className="text-[18px] font-bold text-dark dark:text-dark-text">Adgangen er fjernet</h2>
      <p className="mt-2 text-[14px] text-muted dark:text-dark-muted">
        Virksomheden har fjernet {supplierName}s adgang. Du kan ikke længere se deres projekter og priser.
      </p>
      <button
        type="button"
        onClick={leaveSupplierSession}
        className="mt-6 inline-flex items-center gap-2 rounded-lg bg-primary px-4 py-2.5 text-[14px] font-semibold text-white hover:bg-primary-600"
      >
        <ArrowLeft className="h-4 w-4" />
        Tilbage til {supplierName}
      </button>
    </div>
  );
}
